import collect from "./collect";

export default (id, sections) => {
  let findedNode;

  const findNode = node => {
    if (node.id === id) {
      return true;
    }
  };

  collect(sections, (type, node) => {
    if (node.id === id) {
      findedNode = node;
      return true;
    }
    return false;
  });

  return findedNode;
};
